import { Input, Segmented, Table } from "antd"
import { useState } from "react"
import VSpace from "../../common/VSpace"
import { TenantBudgetReportDataRow } from "./api"
import { useTenantBudgetReportData } from "./queries"
import dayjs from 'dayjs'

const filterRows = (rows: TenantBudgetReportDataRow[] | undefined, filterOption: string, searchText: string) => {
  let result = rows ?? []
  result = result.filter(row => row.tenantName.toLowerCase().includes(searchText.toLowerCase()))

  if (filterOption === '6months') {
    result = result.filter(row => row.daysSinceApplied > 180)
  }

  if (filterOption === '9months') {
    result = result.filter(row => row.daysSinceApplied > 270)
  }

  if(filterOption === '1year') {
    result = result.filter(row => row.daysSinceApplied > 364)
  }

  return result
}

const TenantBudgetReport = () => {
  const tenantBudgetReportDataQuery = useTenantBudgetReportData()
  const [searchText, setSearchText] = useState('')
  const [filterOption, setFilterOption] = useState('all')


  return <VSpace>
    <Input.Search placeholder="Filter tenant name" value={searchText} onChange={e => setSearchText(e.target.value)} />
    <Segmented
      options={[
        { label: 'All (' + (tenantBudgetReportDataQuery.data?.length ?? 0) + ')', value: 'all' },
        { label: '6 Months (' + (tenantBudgetReportDataQuery.data?.filter(row => row.daysSinceApplied > 180).length ?? 0) + ')', value: '6months' },
        { label: '9 Months (' + (tenantBudgetReportDataQuery.data?.filter(row => row.daysSinceApplied > 270).length ?? 0) + ')', value: '9months' },
        { label: '1 Year + (' + (tenantBudgetReportDataQuery.data?.filter(row => row.daysSinceApplied > 364).length ?? 0) + ')', value: '1year' },
      ]}
      value={filterOption}
      onChange={value => setFilterOption(value)}
    />
    <Table
      dataSource={filterRows(tenantBudgetReportDataQuery.data, filterOption, searchText)}
      rowKey="tenantId"
      columns={[
        {
          title: 'Tenant',
          dataIndex: 'tenantName',
          sorter: (a: TenantBudgetReportDataRow, b: TenantBudgetReportDataRow) => a.tenantName.localeCompare(b.tenantName),
          render: (_, record: TenantBudgetReportDataRow) => {
            return <a href={`/#!/tenants?id=${record.tenantId}`}>{record.tenantName}</a>
          }
        },
        {
          title: 'Applied At',
          dataIndex: 'timestamp',
          render: (timestamp: string) => timestamp ? dayjs(timestamp).format('MM/DD/YYYY') : ''
        },
        {
          title: 'Days Since Last Applied',
          dataIndex: 'daysSinceApplied',
          sorter: (a: TenantBudgetReportDataRow, b: TenantBudgetReportDataRow) => a.daysSinceApplied - b.daysSinceApplied,
          render: (daysSinceApplied: number) => {
            return daysSinceApplied
          }
        }
      ]}
    />
  </VSpace>
}

export default TenantBudgetReport
